<script setup lang="ts">
import type { Channel } from "@/types";

defineProps<{
  channels: Channel[];
  height?: number | string;
  link?: boolean;
}>();
defineSlots<{
  append(props: { channel: Channel }): never;
}>();
</script>

<template>
  <VcGuildChannelItem
    v-for="channel in channels"
    :key="channel.id"
    :channel="channel"
    :height="height"
    :link="link"
  >
    <template #line="{ channel: lineChannel }">
      <slot
        name="append"
        :channel="lineChannel"
      />
    </template>
  </VcGuildChannelItem>
</template>
